import * as yup from 'yup';
import { IMobilityGroup } from '../../../types/mobility/IMobilityGroup';

export const MobilitySchemaGenerator = () =>
  yup.object({
    transactionType: yup.string().required(),
  });

export const isDefinedString = (externalId?: string): externalId is string => {
  return !!externalId && externalId.length > 0;
};

export const removeSpecialCharactersAndSpaces = (string: string): string => string.replace(/_|\W/gm, '');

export const MobilityGroupSchemaGenerator = (mobilityGroups: IMobilityGroup[]) => {
  const mobilityGroupExternalIdSet: Set<string> = new Set(
    mobilityGroups
      .map(({ externalId }) => externalId)
      .filter(isDefinedString)
      .map(removeSpecialCharactersAndSpaces)
  );
  return yup.object({
    id: yup.string().nullable(),
    externalId: yup
      .string()
      .nullable()
      .when('id', {
        is: null,
        then: yup
          .string()
          .required()
          .test({
            name: 'new_external_id_is_unique',
            message: 'This external id matches a previous id with this client',
            test: (value: string = '') => !mobilityGroupExternalIdSet.has(removeSpecialCharactersAndSpaces(value)),
          }),
        otherwise: yup.string().notRequired().nullable(),
      }),
    programType: yup.string().nullable(),
    takeTitle: yup.boolean().nullable(),
  });
};

export const MobilityGroupEditionSchemaGenerator = () =>
  yup.object({
    externalId: yup.string().required(),
    programTypeId: yup.string().nullable(),
    takeTitle: yup.boolean().nullable(),
  });

export const MobilitySchema = MobilitySchemaGenerator();
export const MobilityGroupSchema = MobilityGroupSchemaGenerator([]);

export type IMobilitySchema = yup.InferType<typeof MobilitySchema>;
export type IMobilityGroupSchema = yup.InferType<typeof MobilityGroupSchema>;

export const createDefaultMobilityGroupData = (): IMobilityGroupSchema => ({
  id: null as any,
  externalId: null as any,
  programType: null as any,
  takeTitle: null as any,
});

export const createDefaultMobilityData = (): IMobilitySchema => ({
  transactionType: null as never,
});
